export default "__VITE_ASSET__D4mwpRyW__"